<template>
    <div class="footer">
        <div class="copyright">
            Copyright © 2017-{{ getYear }} {{ hostname }}, All Rights Reserved.
        </div>
        <div v-show="goTopShow" @click="gotoTop" class="go-top"><i class="go-top-icon"></i></div>
    </div>
</template>

<script>
    export default {
        name: 'CFooter',
        data() {
            return {
                hostname: location.host,
                scrollTop: 0,
                goTopShow: false
            }
        },
        computed: {
            getYear() {
                return this.$util.timeFormat(new Date(), 'yyyy');
            }
        },
        methods: {
            gotoTop() {
                let timer = null, _that = this;
                cancelAnimationFrame(timer);
                timer = requestAnimationFrame(function fn(){
                    if(_that.scrollTop > 0) {
                        _that.scrollTop -= 50;
                        document.body.scrollTop = document.documentElement.scrollTop = _that.scrollTop;
                        timer = requestAnimationFrame(fn)
                    } else {
                        cancelAnimationFrame(timer);
                        _that.goTopShow = false;
                    }
                })
            },
            scrollFunc() { 
                this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                if(this.scrollTop > 500) {
                    this.goTopShow = true
                } else {
                    this.goTopShow = false
                }
            }
        },
        mounted() {
            window.addEventListener('scroll', this.scrollFunc)
        },
        destroyed () {
            window.removeEventListener('scroll', this.scrollFunc); 
        }
    }
</script>

<style>

</style>